import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Check, Copy } from 'lucide-react';
import { toast as sonnerToast } from "sonner";
import { trackReferralLinkCopied } from '@/lib/tracking';

interface ReferralCardProps {
    referralLink: string;
    referralCode?: string;
}

export const ReferralCard: React.FC<ReferralCardProps> = ({ referralLink, referralCode }) => {
    const [hasCopied, setHasCopied] = useState(false);

    const handleCopyToClipboard = () => {
        if (!referralLink || !referralCode) return;
        navigator.clipboard.writeText(referralLink).then(() => {
            setHasCopied(true);
            sonnerToast.success("Referral link copied to clipboard!");
            trackReferralLinkCopied({ referralCode });
            setTimeout(() => setHasCopied(false), 2500);
        }, (err) => {
            sonnerToast.error("Failed to copy link.");
        });
    };

    return (
        <Card>
          <CardHeader>
            <CardTitle className="text-xl tracking-[-0.02em] text-slate-950">Refer a Friend</CardTitle>
            <CardDescription className="text-slate-600">Share your link. When a new user signs up and subscribes, you'll receive a $10 credit.</CardDescription>
          </CardHeader>
          <CardContent>
              <div className="flex items-center space-x-2">
                <Input id="referral-link" readOnly value={referralLink} className="rounded-xl border-slate-200 bg-white focus-visible:ring-slate-300" />
                <Button variant="outline" size="icon" className="rounded-xl border-slate-200 bg-white hover:bg-slate-50" onClick={handleCopyToClipboard} aria-label="Copy link">
                  {hasCopied ? <Check className="h-4 w-4 text-emerald-600" /> : <Copy className="h-4 w-4" />}
                </Button>
              </div>
          </CardContent>
        </Card>
    );
};
